import React, { useState, useRef, useEffect, useContext } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { v4 as uuidv4 } from "uuid";
import {ContextApi} from "../../../App"


function NumberField({ onMoveUp, onMoveDown, onElementDelete, preset }) {
  // States
  const [element, setElement] = useState({
    id: uuidv4(),
    type: "number",
    properties: {
      label: "Number Element",
      placeholder: "Enter Number Element here...",
      required: true,
      minLengthValidation: 3,
      maxLengthValidation: 4,
    },
    fillableByCandidate: true,
    fillableByHR: false,
    disableField: false,
    isNumber: false,
  });
  const [modal, setModal] = useState(false);
  const [formError, setFormError] = useState("");
  const contextData = useContext(ContextApi)

  // Refs
  const elementLabelRef = useRef();
  const fillableCandidateRef = useRef();
  const fillableHRRef = useRef();
  const elementPlaceholderRef = useRef();
  const elementRequiredRef = useRef();
  const disableFieldRef = useRef();
  const isNumberRef = useRef();
  const minLengthValidationRef = useRef();
  const maxLengthValidationRef = useRef();

  // Effects
  useEffect(() => {
    if (preset !== null && preset && preset !== undefined) {
      setElement((previousState) => {
        return { ...previousState, ...preset };
      });
    }
  }, [preset]);

  // Events
  const toggle = () => setModal(!modal);

  function onEdit() {
    let isnum = /^\d+$/;

    if (
      !isnum.test(minLengthValidationRef.current.value) ||
      !isnum.test(maxLengthValidationRef.current.value)
    ) {
      setFormError("Only Number are allowed");
    } else if (
      parseInt(minLengthValidationRef.current.value) >
      parseInt(maxLengthValidationRef.current.value)
    ) {
      setFormError("Min Length can be less than or equal to Max Length");
    } else {
      setElement((previousState) => {
        previousState.properties.label = elementLabelRef.current.value;
        previousState.properties.placeholder =
          elementPlaceholderRef.current.value;
        previousState.properties.minLengthValidation =
          minLengthValidationRef.current.value;
        previousState.properties.maxLengthValidation =
          maxLengthValidationRef.current.value;
        previousState.properties.required = elementRequiredRef.current.checked;
        previousState.fillableByCandidate =
          fillableCandidateRef.current.checked;
        previousState.fillableByHR = fillableHRRef.current.checked;
        previousState.disableField = disableFieldRef.current.checked;
        previousState.isNumber = isNumberRef.current.checked;
        return previousState;
      });
      setFormError("");
      toggle();
      contextData.setContextData({
        ...contextData.contextData,
        isEdit :!contextData.contextData.isEdit
      })
    }
  }


  return (
    <div
      className="form-group form-builder-element mb-3"
      data={JSON.stringify(element)}
    >
      <button
        className="btn btn-danger btn-circle btn-sm mr-2 btn-builder-right"
        onClick={(e) => onElementDelete(e,element)}
      >
        <i className="fa fa-trash"></i>
      </button>
      <button
        className="btn btn-primary btn-circle btn-sm mr-2 btn-builder-right"
        onClick={toggle}
      >
        <i className="fa fa-asterisk"></i>
      </button>
      <button
        className="btn btn-primary btn-circle btn-sm mr-2 btn-builder-right"
        onClick={onMoveUp}
      >
        <i className="fa fa-chevron-up"></i>
      </button>
      <button
        className="btn btn-primary btn-circle btn-sm mr-2 btn-builder-right"
        onClick={onMoveDown}
      >
        <i className="fa fa-chevron-down"></i>
      </button>
      <label>
        {element.properties.label}
        {element.properties.required && <span style={{color:'red'}}>*</span>}
      </label>
      <input
        className="form-control"
        type="number"
        placeholder={element.properties.placeholder}
      />
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Edit Number Field Properties</ModalHeader>
        <ModalBody>
          <div className="form-group">
            <label>Label</label>
            <input
              ref={elementLabelRef}
              defaultValue={element.properties.label}
              type="text"
              className="form-control"
            />
          </div>
          <div className="form-group">
            <label>Placeholder</label>
            <input
              ref={elementPlaceholderRef}
              type="text"
              className="form-control"
              defaultValue={element.properties.placeholder}
            />
          </div>
          <div className="row d-flex justify-content-between">
            <div className="col-5">
              <div className="form-group">
                <label>Min Length of element</label>
                <input 
                style={{
                  appearance:'none'
                }}
                  ref={minLengthValidationRef}
                  type="number"
                  className="form-control"
                  defaultValue={element.properties.minLengthValidation}
                />
                {formError && (
                  <div className="text-danger" style={{ marginTop: 5 + "px" }}>
                    {formError}
                  </div>
                )}
              </div>
            </div>
            <div className="col-5">
              <div className="form-group">
                <label>Max Length of element</label>
                <input
                  ref={maxLengthValidationRef}
                  type="number"
                  className="form-control"
                  defaultValue={element.properties.maxLengthValidation}
                />
               
              </div>
            </div>
          </div>
          <div className="custom-control custom-checkbox">
            <input
              type="checkbox"
              ref={elementRequiredRef}
              className="custom-control-input"
              id="requiredCheck"
              defaultChecked={element.properties.required}
            />
            <label className="custom-control-label" htmlFor="requiredCheck">
              Mandatory?
            </label>
          </div>
          <div className="custom-control custom-checkbox">
            <input
              type="checkbox"
              ref={fillableCandidateRef}
              className="custom-control-input"
              id="fillableCandidate"
              defaultChecked={element.fillableByCandidate}
            />
            <label className="custom-control-label" htmlFor="fillableCandidate">
              Can candidates edit this field?
            </label>
          </div>

          <div className="custom-control custom-checkbox">
            <input
              type="checkbox"
              ref={fillableHRRef}
              className="custom-control-input"
              id="fillableHR"
              defaultChecked={element.fillableByHR}
            />
            <label className="custom-control-label" htmlFor="fillableHR">
              Can HRs edit this field?
            </label>
          </div>
          <div className="custom-control custom-checkbox">
            <input
              ref={disableFieldRef}
              type="checkbox"
              className="custom-control-input"
              id="disableField"
              defaultChecked={element.disableField}
            />
            <label className="custom-control-label" htmlFor="disableField">
              Disable preFilled Field(only admin can edit)
            </label>
          </div>
          <div className="custom-control custom-checkbox">
            <input
              ref={isNumberRef}
              type="checkbox"
              className="custom-control-input"
              id="isNumber"
              defaultChecked={element.isNumber}
            />
            <label className="custom-control-label" htmlFor="isNumber">
              Only Numbers are allowed?
            </label>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={onEdit}>
            Update
          </Button>{" "}
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default NumberField;
